import api from '../api';

export default {
  index(params) {
    return api.get(`/central/events`, {
      params: params,
    });
  },
  show(id) {
    return api.get(`/central/events/${id}`);
  },
  store(data) {
    return api.post(`/central/events`, data);
  },
  duplicate(id) {
    return api.post(`/central/events/${id}/duplicate`);
  },
  update(id, data, options) {
    return api.patch(`/central/events/${id}`, data, options);
  },
  publish(id, data, options) {
    return api.post(`/central/events/${id}/publish`, data, options);
  },
};
